import React from 'react';
import { useIntl } from 'react-intl';
import { EmptyComponent, TableColumn, TableColumnAlign } from '@eas/common-web';
import { Redirect } from '@composite/redirect/redirect';
import { InfFile } from '@models';
import { EvidenceBrowserUrl } from '@enums';
import { useInfColumns } from '../inf-file-columns';

export function useColumns(): TableColumn<InfFile>[] {
  const intl = useIntl();

  const { columnDeliveryDate, columnIncomingNumber, columnWriters } =
    useInfColumns();

  return [
    {
      datakey: 'id',
      name: intl.formatMessage({
        id: 'ES__INF_FILES_NEW__TABLE__COLUMN__REDIRECT',
        defaultMessage: 'Přesměrování',
      }),
      NameComponent: EmptyComponent,
      width: 50,
      CellComponent: function Cell(props) {
        return (
          <>
            <Redirect
              url={EvidenceBrowserUrl.INF_FILES_NEW}
              id={props.value}
              showRedirectInCurrent={false}
            />
          </>
        );
      },
      align: TableColumnAlign.LEFT,
    },
    columnDeliveryDate,
    columnIncomingNumber,
    columnWriters,
  ];
}
